//TODO: CPR

import angular from 'angular';

import '../../../services/contract';
import '../../../services/user';

angular.module("folkeuni").component("newContracts", {
    templateUrl: "/shop-dist/templates/new-contracts.html?c=" + window.cacheBurst,
    transclude: false,
    bindings: {
        departmentId: "@",
        equipmentDescription: "@",
        pdpUrl: "@"
    },
    controller: function (Contract, User, $timeout) {
        var $ctrl = this;
        $ctrl.loading = true;
        $ctrl.contracts = null;
        $ctrl.userCurrent = null;
        $ctrl.cprError = null;
        $ctrl.addressMissing = false;
        $ctrl.currentContractAccepted = false;
        $ctrl.loadingApprove = false;
        $ctrl.PersonalDataDescriptionLink = "/information-til-forelæsere/folkeuniversitetets-persondatapolitik-vedr-ansættelser-og-undervisere/";

        $ctrl.clearErrors = function (contract) {
            contract.termsError = null;
        };
        // Approve contract
        $ctrl.contractApprove = function (contract) {
            var contractObj = {
                contractId: contract.id,
                lines: [],
                equipment: contract.equipment,
                expectsAttachment: contract.expencesExpected
            };

            for (var i = 0; contract.lines.length > i; i++) {
                var currentContractline = contract.lines[i];
                contractObj.lines.push(currentContractline.lineNo);
            }

            if (contract.currentContractAccepted) {
                $ctrl.loadingApprove = true;
                $ctrl.termsError = null;
                Contract.approve(contractObj).then(
                    function (successResponse) {
                        contract.statusMessage = "Din kontrakt til " + contract.title + " er nu godkendt.";
                        contract.fade = true;
                        contract.notvisible = true;

                        $timeout(function () {
                            return $timeout(function () {
                                contract.fade = true;
                                contract.notvisible = false;
                            }, 3000);
                        }).then(function () {
                            return $timeout(function () {
                                contract.hide = true;
                                $ctrl.loadingApprove = false;
                            }, 1000);
                        });
                    },
                    function (errorResponse) {
                        console.log("error", errorResponse);
                        $ctrl.loadingApprove = false;
                    }
                );
            } else {
                contract.termsError =
                    "For at godkende er det nødvendigt at du giver dit sammentykke til opbevaring af persondata";
            }
        };
        // Reject contract state
        $ctrl.contractReject = function (contract) {
            //    contract.statusMessage = "Du har afvist " + contract.title + " vælg venligst en begrundelse";

            contract.reject = true;

            $timeout(function () {
                return $timeout(function () {
                    contract.rejectform = true;
                }, 500);
            });
        };

        // Cancel reject contract
        $ctrl.contractRejectCancel = function (contract) {
            contract.rejectform = false;
            $timeout(function () {
                return $timeout(function () {
                    contract.reject = false;
                }, 500);
            });
        };
        $ctrl.contractSendReject = function (contract) {
            var contractObj = {
                contractId: contract.id,
                comment: contract.rejectMessage
            };

            Contract.reject(contractObj).then(
                function (successResponse) {
                    contract.statusMessage = "Din kontrakt til " + contract.title + " er nu afvist.";
                    contract.fade = true;
                    contract.rejectformFade = true;
                    contract.messagerejected = true;

                    $timeout(function () {
                        return $timeout(function () {
                            contract.rejectformFade = true;
                            contract.fade = true;
                            contract.messagerejected = false;
                            contract.statusMessage = false;
                        }, 3000);
                    }).then(function () {
                        return $timeout(function () {
                            contract.hide = true;
                        }, 1000);
                    });
                },
                function (errorResponse) {
                    console.log("error", errorResponse);
                }
            );
        };

        $ctrl.cprUpdate = function () {
            var regEx = /^[0-9-]*$/,
                newCPR = $ctrl.userCurrent.employee.cprNew.replace(/-/g, ""),
                isValid = true;

            $ctrl.cprError = null;

            if (!regEx.test(newCPR) || !(newCPR.length == 10)) {
                $ctrl.cprError = "CPR er ikke i det rigtige format. Forventet format er 111111-1111";
                isValid = false;
            }

            if (isValid) {
                User.cprUpdate(newCPR).then(
                    function (succesResponse) {
                        $ctrl.userCurrent.employee.cpr = newCPR;
                        $ctrl.loading = false;
                    },
                    function (errorResponse) {
                        $ctrl.cprError =
                            "Der er sket en fejl i forbindelse med registreringen af dit CPR-nummer. Muligvis er formatet forkert, forventet format er 111111-1111";
                        console.log("error", errorResponse);
                    }
                );
            }
        };

        $ctrl.statusError = function () {
            contract.statusMessage = "Noget gik galt fejlkode:" + contractErrorCode + ".";
        };

        $ctrl.$onInit = function () {
            User.getCurrent().then(
                function (userObj) {
                    $ctrl.userCurrent = userObj;
                    $ctrl.PersonalDataDescriptionLink = $ctrl.handlePersonalDataDescriptionLink();

                    $ctrl.addressMissing =
                        !$ctrl.userCurrent.streetName ||
                        !$ctrl.userCurrent.streetNumber ||
                        !$ctrl.userCurrent.city ||
                        !$ctrl.userCurrent.postalCode;

                    Contract.getAllWaitingApproval().then(
                        function (contractObj) {
                            $ctrl.contracts = contractObj;
                            // og payment method?? den er jo på hver linje
                            $ctrl.loading = false;
                        },
                        function (errorReponse) {
                            $ctrl.loading = false;
                            console.log("Waiting error", errorReponse);
                        }
                    );
                },
                function (errorResponse) {
                    $ctrl.loading = false;
                    console.log("Get current error", errorReponse);
                }
            );
        };

        $ctrl.handlePersonalDataDescriptionLink = () => {
          if ($ctrl.pdpUrl) return $ctrl.pdpUrl;

          // TODO Handles Legacy setup, from before we got the link from umbraco, when all departments uses the new feature delete this
          if ($ctrl.departmentId == 3) {
              return "/information-til-forelæsere/folkeuniversitetets-persondatapolitik-vedr-ansættelser-og-undervisere/";
          } else if ($ctrl.departmentId == 15) {
              return "/om-folkeuniversitetet/information-til-undervisere/folkeuniversitetets-persondatapolitik-vedr-ansættelser-og-undervisere/";
          } else {
              return "/information-til-forelæsere/folkeuniversitetets-persondatapolitik-vedr-ansættelser-og-undervisere/";
          }
        };
    }
});
